<template>
    <div>
        <div style="padding: 15px;">
          <a-form layout="inline">
            <a-row :gutter="18">
              <a-col :md="6" :sm="8">
                <a-input style="width: 240px; margin-right: 8px;" placeholder="keyword" v-model="form.keywords"/>
              </a-col>

              <a-col :md="6" :sm="8">
                <a-form-item :label="$t('platformCollection.state')">
                  <a-select default-value=""
                            style="width: 120px" v-model="form.userstatus">
                    <a-select-option value="">
                      {{ $t('platformCollection.all') }}
                    </a-select-option>
                    <a-select-option value="1">
                      {{ $t('platformCollection.enable') }}
                    </a-select-option>
                    <a-select-option value="2">
                      {{ $t('platformCollection.disable') }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="search(1)">{{ $t('search') }}</a-button>
                <a-button style="margin-left: 10px;" type="primary" @click="createUser('add')"><a-icon type="plus" />{{ $t('add') }}</a-button>
              </span>
              </a-col>
            </a-row>
          </a-form>

        </div>
        <a-table
            :dataSource="list"
            :pagination="false"
            :loading="loading"
            bordered
            @change="handleTableChange">
            <a-table-column
                :title="$t(I18N_KEY + 'index')"
                dataIndex="index"
                key="index"
                align="center"
            />
            <a-table-column
                :title="$t(I18N_KEY + 'name')"
                dataIndex="userName"
                key="userName"
                align="center"
            />
            <a-table-column
                :title="$t('platformCollection.account')"
                dataIndex="mobile"
                key="mobile"
                align="center"
            />
            <!--<a-table-column-->
                <!--:title="$t(I18N_KEY + 'mail')"-->
                <!--dataIndex="email"-->
                <!--key="email"-->
                <!--align="center"-->
            <!--/>-->
            <a-table-column
                :title="$t(I18N_KEY + 'time')"
                dataIndex="createTime"
                key="createTime"
                align="center"
            />
            <a-table-column
                :title="$t(I18N_KEY + 'status')"
                dataIndex="status"
                key="status"
                align="center"
            >
                <template slot-scope="text, record">
                    <a-badge :status="text == 1 ? 'success' : 'default'" />
                    <span>{{ USER_STATUS[text] }}</span>
                </template>
            </a-table-column>
            <a-table-column
                :title="$t(I18N_KEY + 'action')"
                dataIndex="action"
                key="action"
                align="center"
            >
                <template slot-scope="text, record">
                    <span>
                        <a href="javascript:;" @click="createUser('edit', record)">{{ $t(I18N_KEY + 'edit') }}</a>
                        <a-divider type="vertical" />
                        <!-- <a href="javascript:;" @click="deleteCurrent(record)">{{ $t(I18N_KEY + 'delete') }}</a> -->
                    </span>
                </template>
            </a-table-column>
        </a-table>
        <div style="margin-top: 15px; text-align: right;">
            <v-pagination
                v-if="total"
                :page-num="form.pageNum"
                :page-size="form.pageSize"
                :total="total"
                @change="handleTableChange" />
        </div>
        <a-modal
            :title="modalTitle"
            v-model="visible"
            @ok="submitUser"
        >
            <a-form :form="basicForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                <a-form-item :label="$t(I18N_KEY + 'name')">
                  <a-input v-model="basicForm.userName" />
                </a-form-item>

                <a-form-item :label="$t('platformCollection.account')">
                  <a-input v-model="basicForm.mobile" />
                </a-form-item>
                <!--<a-form-item :label="$t(I18N_KEY + 'mail')">-->
                  <!--<a-input v-model="basicForm.email" />-->
                <!--</a-form-item>-->
                <a-form-item :label="$t(I18N_KEY + 'password')">
                  <a-input v-model="basicForm.password" />
                </a-form-item>
                <a-form-item :label="$t(I18N_KEY + 'status')">
                  <a-switch v-model="basicForm.status" />
                </a-form-item>
                <!--<a-form-item :label="$t(I18N_KEY + 'role')">-->
                    <!--<a-select-->
                        <!--mode="multiple"-->
                        <!--v-model="basicForm.roleIds"-->
                    <!--&gt;-->
                        <!--<a-select-option v-for="item in roleList" :key="item.id">-->
                            <!--{{ item.roleName }}-->
                        <!--</a-select-option>-->
                    <!--</a-select>-->
                <!--</a-form-item>-->
                <a-form-item :label="'角色'">
                  <a-select
                    v-model="basicForm.roleCode"
                  >
                    <a-select-option value="xs">
                      信审员
                    </a-select-option>
                    <a-select-option value="xs_zz">
                      信审组长
                    </a-select-option>
                    <a-select-option value="admin_app">
                      管理员
                    </a-select-option>
                  </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import vPagination from '../modules/pagination';
    import { getExamineList,addExamine,editExamine } from '@/webpublicapi/system'
    const I18N_KEY = 'system.userList.';
    export default {
        components: {
            vPagination,
        },
        data () {
            return {
                I18N_KEY,
                visible: false,
                modalTitle: undefined,
                loading: false,
                examineList: [],
                form: {
                    pageNum: 1,
                    pageSize: 10,
                    keywords: undefined,
                    userstatus: undefined
                },
                defaultBasicForm: {
                    userName: undefined,
                    roleCode: 'xs',
                    mobile: undefined,
                    email: undefined,
                    password: undefined,
                    status: true,
                    userstatus: 1
                },
                basicForm: {},
                USER_STATUS: {
                    1: this.$t('platformCollection.enable'),
                    2: this.$t('platformCollection.disable'),
                },

            }
        },
        computed: {

            list () {
                const list = (this.examineList && this.examineList.rows) || [];
                return list.map((item, index) => {
                    return {
                        index: index + 1,
                        ...item,
                    }
                });
            },
            total () {
                return this.examineList && this.examineList.total;
            },
            pagination () {
                return {
                    pageSize: this.form.pageSize,
                    current: this.form.pageNum,
                    total: this.total,
                }
            },
        },
        created () {
            window.xx = this;
            this.basicForm = { ...this.defaultBasicForm };
            this.search();

            // this.getSysGroupOut();
        },
        methods: {

            handleTableChange (pageNum, pageSize) {
                this.form.pageNum = pageNum;
                this.form.pageSize = pageSize;
                this.search();
            },
            changeModal (visible) {
                this.visible = visible;
            },
            createUser (mode, user = {}) {
                this.changeModal(true);
                this.basicForm.userId = user.id;
                if (mode == 'edit') {
                    this.basicForm = {
                        ...this.basicForm,
                        userName: user.userName,
                        mobile: user.mobile,
                        email: user.email,
                        password: user.password,
                        status: user.status == 1,
                        roleCode: user.roleCode,
                    }
                } else {
                    this.basicForm = { ...this.defaultBasicForm };
                }
                this.modalTitle = mode == 'add' ? this.$t('platformCollection.add_user') : this.$t('platformCollection.modify_user')
            },
            deleteCurrent (row) {
                this.$confirm({
                    title: this.$t('platformCollection.delete_user'),
                    content: this.$t('platformCollection.delete_current_user'),
                    onOk: () => {
                        this.loading = true;
                        this.deleteUser({ id: userId.id }).then(res => {
                            this.search(1);
                        }).catch(e => {
                            this.loading = false;
                            this.$message.error(e.message);
                        });
                    }
                });
            },
            submitUser () {
                this.changeModal(false);
                this.loading = true;
                const form = {
                    ...this.basicForm,
                    status: this.basicForm.status ? 1 : 2,
                };

                if(!form.userId){
                  addExamine(form).then(res => {
                    this.loading = false;
                    this.$message.success(this.$t('success'));
                    this.search(1);
                  }).catch(e => {
                    this.loading = false;
                    this.$message.error(e.message);
                  })
                }else{
                  editExamine(form).then(res => {
                    this.loading = false;
                    this.$message.success(this.$t('success'));
                    this.search(1);
                  }).catch(e => {
                    this.loading = false;
                    this.$message.error(e.message);
                  })
                }

            },
            search (pageNum) {
                if(pageNum) { this.form.pageNum = pageNum; }
                this.loading = true;
                getExamineList(this.form).then(res => {
                    this.examineList = res.data || []
                    this.loading = false;
                }).catch(e => {
                    this.loading = false;
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>
